// extracted by mini-css-extract-plugin
module.exports = {"sticky":"style__sticky__cm1fE","top":"style__top__8iGZD","right":"style__right__9IkOK","bottom":"style__bottom__5DR+R","left":"style__left__RLxW5"};